import { createStyleSheet } from '@shared-ui/theme'
import { rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme, { safe }) => ({
  overlay: { flex: 1, justifyContent: 'flex-end' },
  backdrop: { position: 'absolute', inset: 0, backgroundColor: theme.COLOR_NEUTRAL_950, opacity: 0.2 },
  sheet: {
    flexGrow: 0,
    maxHeight: '80%',
    borderTopLeftRadius: rw(24),
    borderTopRightRadius: rw(24),
    backgroundColor: theme.COLOR_BG_BASE,
  },
  content: { padding: rw(24), paddingBottom: rh(24) + safe.bottom },
  row: { flexDirection: 'row', alignItems: 'center', columnGap: rw(12), paddingVertical: rh(16) },
  flag: { width: rw(28), height: rw(28), borderRadius: rw(14) },
  name: { flex: 1 },
}))
